<template>
  <v-snackbar
    v-model="show"
    :timeout="-1"
  >
    {{ $t('common.phrases.newUpdateAvailable') }}
    <v-btn
      color="success"
      class="mr-2"
      :loading="isLoading"
      @click.native="update"
    >
      {{ $t('common.refresh') }}
    </v-btn>
    <v-btn
      color="default"
      icon
      @click.native="show = false">
      <v-icon>{{ mdiCloseCircleOutline }}</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mdiCloseCircleOutline } from '@mdi/js';

export default {
  data() {
    return {
      mdiCloseCircleOutline,
      registration: null,
      show: false,
      isLoading: false,
    };
  },
  created() {
    document.addEventListener(
      'serviceWorkerUpdateEvent', this.appUpdateUI, { once: true },
    );
  },
  methods: {
    appUpdateUI(e) {
      this.show = true;
      this.registration = e.detail;
    },
    update() {
      this.isLoading = true;
      if (this.registration) {
        this.registration.sw.postMessage({ type: 'SKIP_WAITING' });
        this.$log.info('Sent SKIP_WAITING');
      } else {
        this.$log.error('No service worker registration');
      }
    },
  },
};
</script>
